import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';
import { FormControlChildAbstract } from '~/component/form/abstracts/control-child.abstract';

import { InputStyleEnum } from './enums/style.enum';
import { Type } from './enums/type.enum';
import { VtmnPlayIconButtonSizeEnum } from '~/component/buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-size.enum';
import { VtmnPlayIconButtonVariantEnum } from '~/component/buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-variant.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-form-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FormInputComponent,
      multi: true,
    },
  ],
})
export class FormInputComponent extends FormControlChildAbstract<
  string | number
> {
  @Input() public ariaLabel?: string;
  @Input() public freeActivity?: boolean;
  @Input() public inputIconType?: VtmnPlayIconTypeEnum;
  @Input() public inputStyle = InputStyleEnum.Default;
  @Input() public max?: number | string;
  @Input() public min?: number | string;
  @Input() public name?: string;
  @Input() public pattern?: string;
  @Input() public placeholder?: string;
  @Input() public promoCodeStatus?: {};
  @Input() public readonly = false;
  @Input() public rightButtonAriaLabel?: string;
  @Input() public rightButtonIconType?: VtmnPlayIconTypeEnum;
  @Input() public type = Type.Text;

  @Output() public readonly focusInput = new EventEmitter<void>();
  @Output() public readonly keyDownEnterInput = new EventEmitter<Event>();
  @Output() public readonly rightButtonClick = new EventEmitter<void>();

  public readonly ctaButtonTypeButton = CtaButtonTypeEnum.Button;
  public readonly vtmnPlayIconButtonSize = VtmnPlayIconButtonSizeEnum;
  public readonly vtmnPlayIconButtonVariant = VtmnPlayIconButtonVariantEnum;

  constructor(private readonly inputElement: ElementRef) {
    super();
  }

  public get inputContainerClass(): string {
    const inputClasses = [];
    if (this.inputStyle === InputStyleEnum.Shadowed) {
      inputClasses.push('input-container--shadowed');
    }

    if (this.inputStyle === InputStyleEnum.Transparent) {
      inputClasses.push('input-container--transparent');
    }

    if (this.inputIconType) {
      inputClasses.push('input-container--with-icon');
    }

    if (this.promoCodeHasStatus) {
      inputClasses.push(
        'input-container--' + Object.keys(this.promoCodeStatus)[0]
      );
    }

    return inputClasses.join(' ');
  }

  public get promoCodeHasStatus(): boolean {
    return this.promoCodeStatus !== undefined && this.promoCodeStatus !== null;
  }

  public focus(): void {
    this.inputElement.nativeElement.querySelector('input').focus();
  }

  public keyDownEnter($event: Event): void {
    this.keyDownEnterInput.emit($event);
  }
}
